// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  GOOGLE_MAP_KEY: "AIzaSyDkpAuKvwaEbxDhzlt_qL2u_MDgrDwZYC0",
  ambulanceType: ['', 'ALS', 'BLS', 'Patient Transport', 'Mortuary', 'Mortuary(PT)'],
  serviceStatus:
    // [
    //   { name: "Pending", value: 0 },
    //   { name: "IN Process", value: 1 },
    //   { name: "Booked", value: 2 },
    //   { name: "En-route", value: 3 },
    //   { name: "Completed", value: 4 },
    //   { name: "NotFulfilled", value: 5 },
    //   { name: "Cancelled", value: 9 },
    // ],
    [
      { name: "Pending", value: 0 },
      { name: "Booked", value: 1 },
      { name: "At Scene", value: 2 },
      { name: "En-route", value: 3 },
      { name: "Completed", value: 4 },
      { name: "NotFulfilled", value: 5 },
      { name: "Cancelled", value: 9 },
    ],

  chiefComplaint:
    [
      // { name: "Accident/  Road accident", value: 1, type: 1 },
      // { name: "Allergic reaction", value: 2, type: 2 },
      // { name: "Animal bites/ Insect bites/ Snake bite", value: 3, type: 1 },
      // { name: "Asthama /Breathing Difficulty", value: 4, type: 1 },
      // { name: "High Blood Pressure", value: 5, type: 1 },
      // { name: "Burns", value: 6, type: 1 },
      // { name: "Chest pain", value: 7, type: 1 },
      // { name: "Choking", value: 8, type: 1 },
      // { name: "Delivery and Gyne problems", value: 9, type: 1 },
      // { name: "Diabetes / Hypoglycemia", value: 10, type: 1 },
      // { name: "Drowning", value: 11, type: 1 },
      // { name: "Drug Over dose /Alcohalism", value: 12, type: 1 },
      // { name: "Electric Shock", value: 13, type: 1 },
      // { name: "Epileptic seizure", value: 14, type: 1 },
      // { name: "Fall From Height", value: 15, type: 1 },
      // { name: "Heat Stroke", value: 16, type: 1 },
      // { name: "High Grade fever", value: 17, type: 1 },
      // { name: "Paralysis ", value: 18, type: 1 },
      // { name: "Poisoning", value: 19, type: 1 },
      // { name: "Psychiatric Problem", value: 20, type: 1 },
      // { name: "Spine problem ", value: 21, type: 1 },
      // { name: "Suicide", value: 22, type: 1 },
      // { name: "Unconscious", value: 23, type: 1 },
      // { name: "Vomiting/ Dehydration", value: 24, type: 1 },
      // { name: "Scheduled call ", value: 26, type: 2 },
      // { name: "Airport Pickup ", value: 27, type: 2 },
      // { name: "Mortuary Van ", value: 28, type: 2 },
      // { name: "Dialysis", value: 29, type: 2 },
      // { name: "Regular check ", value: 30, type: 2 },
      // { name: "Post Operative checkup ", value: 31, type: 2 },
      // { name: "Patient Can not walk ", value: 32, type: 2 },
      // { name: "Inter hospital transfer ", value: 33, type: 2 },
      // { name: "Enquiry ", value: 34, type: 3 },
      // { name: "Other ", value: '', type: '' },


      { name: "Abdominal aortic aneurysm", value: 1, type: 1 },
      { name: "Accident RTA", value: 2, type: 1 },
      { name: "Airport landing emergency", value: 3, type: 2 },
      { name: "Allergic reaction", value: 4, type: 1 },
      { name: "Animal bitesInsect bites", value: 5, type: 1 },
      { name: "Assault", value: 6, type: 1 },
      { name: "Asthama", value: 7, type: 1 },
      { name: "B P Issue", value: 8, type: 1 },
      { name: "Bomb Blast", value: 9, type: 1 },
      { name: "Breathing Difficulty", value: 10, type: 1 },
      { name: "Building Collapse", value: 11, type: 1 },
      { name: "Burns", value: 12, type: 1 },
      { name: "Cancer", value: 13, type: 1 },
      { name: "Chest pain", value: 14, type: 1 },
      { name: "Choking", value: 15, type: 1 },
      { name: "Corona suspected", value: 16, type: 1 },
      { name: "Corona virus", value: 17, type: 1 },
      { name: "Delivery", value: 18, type: 1 },
      { name: "Demolition", value: 19, type: 1 },
      { name: "Dengue", value: 20, type: 2 },
      { name: "Deployement", value: 21, type: 2 },
      { name: "Diabetic problem", value: 22, type: 1 },
      { name: "Dialysis", value: 23, type: 2 },
      { name: "Domestic Violence", value: 24, type: 1 },
      { name: "Drowning", value: 25, type: 1 },
      { name: "Drug Over dose", value: 26, type: 1 },
      { name: "EARTHQUAKE", value: 27, type: 1 },
      { name: "Electric Shock", value: 28, type: 1 },
      { name: "Epileptic seizure", value: 29, type: 1 },
      { name: "Eye problem", value: 30, type: 2 },
      { name: "Fall From Height", value: 31, type: 1 },
      { name: "Fire", value: 32, type: 1 },
      { name: "Fracture", value: 33, type: 1 },
      { name: "Group Clash", value: 34, type: 1 },
      { name: "Gunshot", value: 35, type: 1 },
      { name: "Gynecological problem", value: 36, type: 1 },
      { name: "Haemorrhage", value: 37, type: 1 },
      { name: "Hanging", value: 38, type: 1 },
      { name: "Hazardous Material Exposure", value: 39, type: 1 },
      { name: "Head Injury", value: 40, type: 1 },
      { name: "Heart Attack", value: 41, type: 1 },
      { name: "Heat Stroke", value: 42, type: 1 },
      { name: "High Grade Fever", value: 43, type: 1 },
      { name: "Hypothermia", value: 44, type: 1 },
      { name: "Industrial Accidents", value: 45, type: 1 },
      { name: "Interhospital Transfer", value: 46, type: 1 },
      { name: "Jaundice", value: 47, type: 2 },
      { name: "Mental Health", value: 48, type: 1 },
      { name: "Mock Drill", value: 49, type: 2 },
      { name: "Monkey Pox", value: 50, type: 2 },
      { name: "Others", value: 51, type: 0 },
      { name: "Paralysis", value: 52, type: 1 },
      { name: "Penetrating Trauma Stab", value: 53, type: 1 },
      { name: "Poisoning", value: 54, type: 1 },
      { name: "Post Delivery Drop back to at Home", value: 55, type: 2 },
      { name: "Post delivery PV Bleed", value: 56, type: 1 },
      { name: "Psychiatric Problem", value: 57, type: 1 },
      { name: "Riot", value: 58, type: 1 },
      { name: "Severe Headache", value: 59, type: 1 },
      { name: "Sexual Abuse", value: 60, type: 1 },
      { name: "Severe Back pain", value: 61, type: 1 },
      { name: "Spine problem", value: 62, type: 1 },
      { name: "Strangulation", value: 63, type: 1 },
      { name: "Suicide", value: 64, type: 1 },
      { name: "Stabbing", value: 65, type: 1 },
      { name: "Seizures", value: 66, type: 1 },
      { name: "TB", value: 67, type: 2 },
      { name: "Train Related Accident", value: 68, type: 1 },
      { name: "TestEvent", value: 69, type: 2 },
      { name: "Traumatic Injury", value: 70, type: 1 },
      { name: "Unconscious", value: 71, type: 1 },
      { name: "Vomiting", value: 72, type: 2 },
      { name: "Deployment", value: 73, type: 4 },
      { name: "N.C.W", value: 74, type: 5 },
      { name: "Dead Body", value: 77, type: 2 },
      { name: "OPD", value: 78, type: 2 },
      { name: "Injury (other)", value: 79, type: 2 },
      { name: "Surgery", value: 80, type: 2 },
      { name: "After Surgery checkup", value: 81, type: 2 },
      { name: "Liver cirrhosis", value: 82, type: 2 },
      { name: "Checkup", value: 83, type: 2 },
      { name: "Discharge", value: 84, type: 2 },
      { name: "Routine Checkup", value: 85, type: 2 },
      { name: "Service Call", value: 86, type: 2 },
      { name: "Event", value: 87, type: 2 },
      { name: "Brain Hemorrhage", value: 88, type: 1 },
      { name: "Bed Ridden", value: 89, type: 1 },
      { name: "Miscellaneous", value: 90, type: 2 },
      { name: "Immobility", value: 91, type: 2 },
      { name: "Chronic UTI", value: 92, type: 2 },
      { name: "Home transfer", value: 93, type: 2 },
      { name: "Skin issue", value: 94, type: 2 },
      { name: "Stomach pain", value: 95, type: 2 },

    ],

  case: [
    { id: 1, name: 'emergency' },
    { id: 2, name: 'nonemergency' }
  ],

  companyChiefComplaint:
    [
      { name: "Abdominal aortic aneurysm", value: 1, type: 1 },
      { name: "Accident RTA", value: 2, type: 1 },
      { name: "Airport landing emergency", value: 3, type: 2 },
      { name: "Allergic reaction", value: 4, type: 1 },
      { name: "Animal bitesInsect bites", value: 5, type: 1 },
      { name: "Assault", value: 6, type: 1 },
      { name: "Asthama", value: 7, type: 1 },
      { name: "B P Issue", value: 8, type: 2 },
      { name: "Bomb Blast", value: 9, type: 1 },
      { name: "Breathing Difficulty", value: 10, type: 1 },
      { name: "Building Collapse", value: 11, type: 1 },
      { name: "Burns", value: 12, type: 1 },
      { name: "Cancer", value: 13, type: 1 },
      { name: "Chest pain", value: 14, type: 1 },
      { name: "Choking", value: 15, type: 1 },
      { name: "Corona suspaected", value: 16, type: 1 },
      { name: "Covid Patient", value: 17, type: 2 },
      { name: "Cardiac Arrest", value: 18, type: 1 },
      { name: "Delivery Pains", value: 19, type: 1 },
      { name: "Dialysis", value: 20, type: 1 },
      { name: "Diarrhea", value: 21, type: 2 },
      { name: "Diabetic emergency", value: 22, type: 1 },
      { name: "Drowning Case", value: 23, type: 1 },
      { name: "Deadbody transfer", value: 24, type: 2 },
      { name: "Ear Pain", value: 25, type: 2 },
      { name: "Electricity emergency", value: 26, type: 1 },
      { name: "Eye Problem", value: 27, type: 2 },
      { name: "Fire emergency", value: 28, type: 1 },
      { name: "Fever", value: 29, type: 2 },
      { name: "Flooding", value: 30, type: 1 },
      { name: "Fracture", value: 31, type: 1 },
      { name: "Gynae related", value: 32, type: 1 },
      { name: "Inter hospital transfer ", value: 33, type: 2 },
      { name: "Interstate transfer", value: 34, type: 2 },
      { name: "Labour pain", value: 35, type: 1 },
      { name: "Leg Pain", value: 36, type: 2 },
      { name: "Migrane pain ", value: 37, type: 2 },
      { name: "Multi organ failure", value: 38, type: 1 },
      { name: "Neuro Case", value: 39, type: 2 },
      { name: "Not specified", value: 40, type: 1 },
      { name: "Other", value: 41, type: 1 },
      { name: "Poisoning", value: 42, type: 1 },
      { name: "Pregnancy emergency", value: 43, type: 1 },
      { name: "Psychiatric emergency", value: 44, type: 1 },
      { name: "Road traffic accident", value: 45, type: 1 },
      { name: "Respiratory distress", value: 46, type: 1 },
      { name: "Rashes", value: 47, type: 2 },
      { name: "Snake bite", value: 48, type: 1 },
      { name: "Stroke", value: 49, type: 1 },
      { name: "Stomach pain", value: 50, type: 2 },
      { name: "Suicidal attempt", value: 51, type: 1 },
      { name: "Trauma", value: 52, type: 1 },
      { name: "Uncontrolled bleeding", value: 53, type: 1 },
      { name: "Unwell patient", value: 54, type: 2 },
      { name: "Unconscious patient", value: 55, type: 1 },
      { name: "Vomiting & loose motion", value: 56, type: 2 },
      { name: "Water logging", value: 57, type: 1 },
      { name: "Weakness", value: 58, type: 2 },
      { name: "Heat Stroke", value: 59, type: 1 },
      { name: "Sexual Abuse", value: 60, type: 1 },
      { name: "Severe Back pain", value: 61, type: 1 },
      { name: "Spine problem ", value: 62, type: 1 },
      { name: "Strangulation", value: 63, type: 1 },
      { name: "Suicide", value: 64, type: 1 },
      { name: "Stabbing", value: 65, type: 1 },
      { name: "Seizures", value: 66, type: 1 },
      { name: "TB", value: 67, type: 2 },
      { name: "Train Related Accident", value: 68, type: 1 },
      { name: "TestEvent", value: 69, type: 2 },
      { name: "Traumatic Injury", value: 70, type: 1 },
      { name: "Unconscious", value: 71, type: 1 },
      { name: "Vomiting", value: 72, type: 2 },
      { name: "Deployment", value: 73, type: 4 },
      { name: "N.C.W", value: 74, type: 5 },
      { name: "Dead Body", value: 77, type: 2 },

    ],




  firebaseConfig: {
    apiKey: '"AIzaSyBrUaRrLRldVL6idcaCNCvzz1dqCpRUj0U"',
    authDomain: 'cats-e97d6.firebaseapp.com',
    databaseURL: 'https://cats-e97d6-e7fce.firebaseio.com',
    projectId: 'cats-e97d6',
    storageBucket: 'cats-e97d6.appspot.com',
    messagingSenderId: '348669827980',
    appId: '1:348669827980:web:7a099484e82aab43e254a9',
    measurementId: "G-WG08G8358D"
  },
  cancellationReasons: [
    { name: "Ambulance Enquiry", value: 1 },
    { name: "Price is High", value: 2 },
    { name: "Delay In Ambulance Dispatch", value: 3 },
    { name: "Patient is no more", value: 4 },
    { name: "Previous Experience was not Good", value: 5 },
    { name: "Customer Cancelled on Helpline ( No Reason)", value: 6 },
    { name: "Did Not Pick Follow Up Call (Dispatch Team)", value: 7 },
    { name: "Not Waited for Ambulance Dispatch TAT", value: 8 },
    { name: "Customer denied to wait for 15-20 minutes", value: 9 },
    { name: "Customer not picked up the Follow Up(Dispatch ) Call", value: 10 },
    { name: "Delay In Ambulance Dispatch", value: 11 },
    { name: "Taken Services from Another Partner", value: 12 },
    { name: "Enquiry for Booked Case", value: 13 },
    { name: "Customer Disconnected the call", value: 14 },
    { name: "Not Responding on Follow Up Call", value: 15 },
    { name: "Enquired for Other Product", value: 16 },
    { name: "Need Free Ambulance Services", value: 17 },
    { name: "Arranged By Himself", value: 18 },
    { name: "Not Interested", value: 19 },
    { name: "Others", value: 20 },
    { name: "Unable to confirm the address", value: 21 },
    { name: "Test Call", value: 22 },
    { name: "Language Barrier", value: 23 },
    { name: "Customer called in by mistake", value: 24 },
    { name: "Vendor /Tie Up Call", value: 25 },
    { name: "Follow Up Call", value: 26 },
    { name: "Service (BLS, ALS, PT, Mortuary) Not Available", value: 27 },
  ],

  OLA_apiKey: 'cBkmzKLVE30bu03Q5kj9atA6nyLSarOKwMNS6F7h',  // Replace with your Ola Maps API Key
  OLA_baseUrl: 'https://api.olamaps.io/places/v1',

  paymentStatus:[
      { name: "Pending", value: 0 },
      { name: "Paid", value: 1 },
    ],


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
